const DECIMAL_SIZE_CLASSES = {
  sm: 'text-xs xl:text-sm',
  base: 'text-sm xl:text-base',
  lg: 'text-lg xl:text-2xl',
} as const

interface PriceDisplayProps {
  price: number
  size?: keyof typeof DECIMAL_SIZE_CLASSES
  currency?: string
  className?: string
}

/**
 * PriceDisplay - Formatted price with visually separated decimal
 *
 * Self-contained UiBlock for consistent price rendering.
 * Splits price into integer + smaller decimal part + currency.
 */
export function PriceDisplay({ price, size = 'base', currency = 'Lei', className }: PriceDisplayProps) {
  if (price === 0) return null

  const parts = price.toFixed(2).split('.')

  return (
    <span className={className}>
      {parts[0]}
      <span className={DECIMAL_SIZE_CLASSES[size]}>
        .{parts[1]}
      </span>
      {' '}{currency}
    </span>
  )
}
